import URI from 'urijs'

import {API_BASE} from 'shared/constants/Api'

export const TIMESHEETS_LIST = (params) => { return URI(`${API_BASE}/api/v2/timesheets/time_records/`).addSearch(params) }
export const TIMESHEET_INFO = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/timesheets/time_records/${id}/`).addSearch(params) }
export const TIMESHEET_CREATE = (params) => { return URI(`${API_BASE}/api/v2/timesheets/time_records`).addSearch(params) }
